import gql from 'graphql-tag';

export const TOPIC_FRAGMENT = gql`
  fragment topicFragment on Topic {
    id
    title
    content
  }
`;

export const FAQ_CATEGORY = gql`
  ${TOPIC_FRAGMENT}
  query faqCategory($id: ID!) {
    faqCategory(id: $id) {
      topics {
        ...topicFragment
      }
    }
  }
`;

export const FAQ_CATEGORIES = gql`
  ${TOPIC_FRAGMENT}
  query faqCategories($first: Int, $name: String) {
    faqCategories(first: $first, name: $name) {
      totalCount
      edges {
        node {
          id
          name
          topics {
            ...topicFragment
          }
        }
      }
    }
  }
`;

export const FAQ_TOPICS = gql`
  ${TOPIC_FRAGMENT}
  query faqTopics($first: Int, $query: String) {
    faqTopics(first: $first, query: $query) {
      totalCount
      edges {
        node {
          ...topicFragment
        }
      }
    }
  }
`;
